import { parseQuery } from '@calendly/http-tools'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

function makeExtensionInfo(search) {
  const query = parseQuery(search)
  const isExtension = query.client || (query.poll && 'platform' in query && 'version' in query)
  return {
    isExtension,
    platform: query.platform,
    version: query.version,
    source: query.source
  }
}

export function useExtensionClient() {
  const location = useLocation()
  const [extensionInfo, setExtensionInfo] = useState(makeExtensionInfo(location.search))

  useEffect(() => {
    setExtensionInfo(makeExtensionInfo(location.search))
  }, [location.search])
  return extensionInfo
}
